export const EXTEND_VISIBILITY_LABEL: { [key: string]: string } = {
	visibility_label: "Sichtbarkeit (Kacheln)",
};
